<template>
  <div class="h-100 favorites-widget">
    <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
      <v-card-title class="pt-1 pb-0 white--text d-flex align-center justify-space-between" :class="$vuetify.theme.dark ? 'black' : 'primary'">
        <div class="d-flex align-center">
          <v-icon color="white" class="mr-2" medium>star</v-icon>
          <span class="white--text body-font body-1 font-weight-bold text-uppercase">{{$t("dashboards.myFavorites")}}</span>
        </div>
        <v-btn class="pl-0 pr-0" text small :to="`/favorites`">
          <span class="white--text text-decoration-underline font-weight-bold">{{$t('general.seeAll')}}</span>
          <v-icon small class="ml-1" color="white">keyboard_arrow_right</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="d-flex flex-column pb-1 flex-grow-1 pa-0" style="overflow:auto;">
        <!--Tabs-->
        <div class="grey lighten-4 tabs-subheader-container">
          <v-btn-toggle
            v-model="tabModel"
            tile
            group
            dense
            mandatory
            class="tabs-subheader d-flex w-100"
            style="width: 100%;"
          >
            <v-btn :value="0" class="flex-grow-1">
              <span class="body-2 font-weight-bold text-uppercase">{{$t('general.players')}}</span>
            </v-btn>
            <v-btn :value="1" class="flex-grow-1">
              <span class="body-2 font-weight-bold text-uppercase">{{$t('playerScout.teams')}}</span>
            </v-btn>
            <v-btn :value="2" class="flex-grow-1">
              <span class="body-2 font-weight-bold text-uppercase">{{$t('app.leagues')}}</span>
            </v-btn>
          </v-btn-toggle>
        </div>
        <!--Items-->
        <div style="background:transparent" class="overflow-auto h-100 px-3 pt-2">
          <!--Players-->
          <div v-if="tabModel === 0" class="transparent">
            <div class="d-flex flex-column" v-if="(players && players.length) && !loading">
              <PlayerDashboardItem
                v-for="(player,index) in players"
                :key="index"
                :player="player"
                embedded
              />
            </div>
            <div
              class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1"
              v-if="(!players || !players.length) && !loading"
            >
              <v-icon
                color="primary lighten-5"
                v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}"
              >star</v-icon>
              <span class="primary--text lighten--text-2 body-1">
                {{$t("dashboards.placeholderFavorites")}}
              </span>
            </div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item@10"
              class="flex-grow-1"
            ></v-skeleton-loader>
          </div>

          <!--Teams-->
          <div v-if="tabModel === 1" class="transparent">
            <div class="d-flex flex-column" v-if="(teams && teams.length) && !loading">
              <div
                class="d-flex justify-space-between align-center py-1"
                v-for="(team,index) in teams"
                :key="index"
              >
                <router-link
                  :to="'/team/'+team.teamId"
                  class="nav-link d-flex align-center"
                >
                  <img
                    @error="onImageLoadFailure($event,'team')"
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + team.teamId + '.png'"
                    style="height: 22px; width: 22px;"
                  />
                  <div
                    class="mx-2 body-1 text-ellipsis"
                    v-bind:style="{'max-width': !$vuetify.breakpoint.xlOnly ? '120px' :''}"
                  >{{team.teamName}}</div>
                </router-link>
                <span class="body-2">{{team.leagueName}}</span>
              </div>
            </div>
            <div
              class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1"
              v-if="(!teams || !teams.length) && !loading"
            >
              <v-icon
                color="primary lighten-5"
                v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}"
              >star</v-icon>
              <span class="primary--text lighten--text-2 body-1">
                {{$t("dashboards.placeholderTeamFavorites")}}
              </span>
            </div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item@10"
              class="flex-grow-1"
            ></v-skeleton-loader>
          </div>

          <!--Leagues-->
          <div v-if="tabModel === 2" class="transparent">
            <div class="d-flex flex-column" v-if="(leagues && leagues.length) && !loading">
              <div
                class="d-flex justify-space-between align-center py-1"
                v-for="(league,index) in leagues"
                :key="index"
              >
                <router-link
                  :to="'/league/'+league.leagueId"
                  class="nav-link d-flex align-center"
                >
                  <img
                    @error="onImageLoadFailure($event,'league')"
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + league.leagueId + '.png'"
                    style="height: 22px; width: 22px;"
                  />
                  <div
                    class="mx-2 body-1 text-ellipsis"
                    v-bind:style="{'max-width': !$vuetify.breakpoint.xlOnly ? '120px' :''}"
                  >{{league.leagueName}}</div>
                </router-link>
                <span class="body-2">{{league.countryName}}</span>
              </div>
            </div>
            <div
              class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1"
              v-if="(!leagues || !leagues.length) && !loading"
            >
              <v-icon
                color="primary lighten-5"
                v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}"
              >star</v-icon>
              <span class="primary--text lighten--text-2 body-1">
                {{$t("dashboards.placeholderLeagueFavorites")}}
              </span>
            </div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item@10"
              class="flex-grow-1"
            ></v-skeleton-loader>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PlayerService from "../../../services/player/player.service";
import TeamService from "../../../services/team/team.service";
import LeagueService from "../../../services/league.service";
import PlayerDashboardItem from '../../player/PlayerDashboardItem';

export default {
  name: "FavoritesWidget",
  components:{
    PlayerDashboardItem
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      players: null,
      teams: null,
      leagues: null,
      tabModel: 0,
      loading: false
    };
  },
  filters: {
  },
  async mounted() {
    await this.loadViewData();
  },
  methods: {
    async loadViewData() {
      await this.loadFavorites();
    },
    async loadFavorites() {
      this.loading = true;
      let onlySelf = true;
      let favoritesResponse =  await PlayerService.getFollowedPlayers(this.userId,onlySelf);
      this.players = _.slice(favoritesResponse.data,0,10);
      let teamFavoritesResponse =  await TeamService.getFollowedTeams(this.userId,onlySelf);
      this.teams = _.slice(teamFavoritesResponse.data,0,10);
      let leagueFavoritesResponse =  await LeagueService.getFollowedLeagues(this.userId,onlySelf);
      this.leagues = _.slice(leagueFavoritesResponse.data,0,10);
      this.loading = false;
    },
    onImageLoadFailure(event, type) {
      if (type === "league" || type === "team") {
        event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
      }
    },
  }
};
</script>

<style scoped>
/* ============================================
   Header and Container Borders
   ============================================ */
.header-with-border {
  border-bottom: 2px solid white;
}

.tabs-subheader-container {
  border-top: 2px solid white;
}

/* ============================================
   Button Toggle Styling
   ============================================ */
.favorites-widget .v-btn-toggle.tabs-subheader {
  background-color: transparent;
  box-shadow: none;
}

.favorites-widget .v-btn-toggle.tabs-subheader .v-btn {
  border-radius: 0;
  text-transform: none;
  margin: 0;
  padding: 12px 16px;
  flex: 1;
  min-width: 0;
}

/* Active button (selected) */
.favorites-widget .v-btn-toggle.tabs-subheader .v-btn--active {
  background-color: rgba(31, 41, 55, 0.8) !important;
  color: white !important;
}

.favorites-widget .v-btn-toggle.tabs-subheader .v-btn--active * {
  color: white !important;
  font-weight: bold !important;
}

/* Inactive button (unselected) */
.favorites-widget .v-btn-toggle.tabs-subheader .v-btn:not(.v-btn--active) {
  background-color: rgba(0, 0, 0, 0.1) !important;
  color: black !important;
}

.favorites-widget .v-btn-toggle.tabs-subheader .v-btn:not(.v-btn--active) * {
  color: black !important;
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/FavoritesWidget.vue